import { render, staticRenderFns } from "./NavLinks.vue?vue&type=template&id=16d5279e&"
import script from "./NavLinks.vue?vue&type=script&lang=ts&"
export * from "./NavLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkExternal: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/LinkExternal.vue').default,NavBarDown: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/NavBarDown.vue').default})
